import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\ItemDossier\DeleteItemModelController::__invoke
* @see app/Http/Controllers/Dossier/ItemDossier/DeleteItemModelController.php
* @route '/api/dossier/{dossier}/model/{model_id}/item-dossier/{itemDossier}'
*/
const DeleteItemModelController = (args: { dossier: string | number | { id: string | number }, model_id: string | number, itemDossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, model_id: string | number, itemDossier: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteItemModelController.url(args, options),
    method: 'delete',
})

DeleteItemModelController.definition = {
    methods: ["delete"],
    url: '/api/dossier/{dossier}/model/{model_id}/item-dossier/{itemDossier}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Dossier\ItemDossier\DeleteItemModelController::__invoke
* @see app/Http/Controllers/Dossier/ItemDossier/DeleteItemModelController.php
* @route '/api/dossier/{dossier}/model/{model_id}/item-dossier/{itemDossier}'
*/
DeleteItemModelController.url = (args: { dossier: string | number | { id: string | number }, model_id: string | number, itemDossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, model_id: string | number, itemDossier: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
            model_id: args[1],
            itemDossier: args[2],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
        model_id: args.model_id,
        itemDossier: typeof args.itemDossier === 'object'
        ? args.itemDossier.id
        : args.itemDossier,
    }

    return DeleteItemModelController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace('{model_id}', parsedArgs.model_id.toString())
            .replace('{itemDossier}', parsedArgs.itemDossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\ItemDossier\DeleteItemModelController::__invoke
* @see app/Http/Controllers/Dossier/ItemDossier/DeleteItemModelController.php
* @route '/api/dossier/{dossier}/model/{model_id}/item-dossier/{itemDossier}'
*/
DeleteItemModelController.delete = (args: { dossier: string | number | { id: string | number }, model_id: string | number, itemDossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, model_id: string | number, itemDossier: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteItemModelController.url(args, options),
    method: 'delete',
})

export default DeleteItemModelController